export const PRODUCTION_CONTROL_PER_TEAM = '/production_control_per_team/';
